module.exports = __webpack_public_path__ + "static/img/linda_motivated.711cb69.png";